var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewFolderAccent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#1D83EA",
    strokeWidth: 1.5,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.167 15.117a1.246 1.246 0 011.25 1.25h0v7.666a1.246 1.246 0 01-1.25 1.25h0H6.833a1.246 1.246 0 01-1.25-1.25h0v-8.916zM10.058 11.367a1.248 1.248 0 011.186.854h0l.882 2.646H5.583v-2.25a1.246 1.246 0 011.25-1.25h0z"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 4.61v6.667M24.334 7.943h-6.667"
  })))));
}
export default SvgNewFolderAccent;